import { Mensaje, TipoMensaje } from './Mensaje';

export class Notificacion {
    public mensajes: Array<Mensaje> = [];

    public static parse(notificacion: any): Notificacion {
        const retorno: Notificacion = new Notificacion();
        if (notificacion != null) {
            retorno.mensajes = notificacion.mensajes;
        }
        return retorno;
    }

    constructor(tipo: TipoMensaje = null, contexto: string  = null, mensaje: string  = null) {
        this.agregarMensaje(tipo, contexto, mensaje);
    }

    public hayErrores(): boolean {
        for (const mensaje of this.mensajes) {
            if (mensaje.tipo === TipoMensaje.ERROR) { return true; }
        }
        return false;
    }

    agregarMensaje(tipo: TipoMensaje, contexto: string, mensaje: string): void {
        const msg: Mensaje = new Mensaje();
        msg.tipo = tipo;
        msg.contexto = contexto;
        msg.texto = mensaje;
        this.mensajes.push(msg);
    }

    unir(notificacion: Notificacion): Notificacion {
        this.mensajes.concat(notificacion.mensajes);
        return this;
    }

    agregarVariable(nombre: string, valor: any): void {
        const mensaje: string = '[Variable] "' + nombre + '" = "' + valor.toString() + '"';
        this.agregarMensaje(TipoMensaje.DEBUG, nombre, mensaje);
    }

    agregarExcepcion(ex: any, contexto: string = null): void {
        if (ex instanceof Mensaje) {
            this.mensajes.push(ex);
        } else {
            this.agregarMensaje(TipoMensaje.ERROR, contexto, ex.Message);
        }
    }
}

export class NotificacionGenerica<T> extends Notificacion {
    public respuesta: T;

    public static parse<T>(notificacion: any): NotificacionGenerica<T> {
        const retorno: NotificacionGenerica<T> = new NotificacionGenerica<T>();
        if (notificacion != null) {
            retorno.mensajes = notificacion.mensajes;
            retorno.respuesta = notificacion.respuesta;
        }
        return retorno;
    }
}
